<div class="map-container">
  <form [formGroup]="mapForm">
    <div class="scroll-display" (scroll)="onScroll($event)">
        <div class="map-input-container">
          <app-text-input
            [placeholder]="'Dirección de tu comercio'"
            [labelText]="'Dirección de tu comercio'"
            formControlName="locationStreet"
            [required]="true"
            [submitted]="submitted"
          ></app-text-input>
          <label *ngIf="directionWarning" class="warning-label"
            >Formato invalido, ej. a ingresar: "Honduras 123"
          </label>
          <div class="container-click" (keydown)="getAutomaticLocation()" (click)="getAutomaticLocation()">
            <mat-icon class="icon-gps">gps_fixed</mat-icon>
            <label class="input-label">Clic aquí para usar mi ubicación actual</label>
          </div>
        </div>
        <div class="parent">
          <div class="map-input-container-city">
            <app-text-input
              [placeholder]="'Ciudad'"
              [labelText]="'Ciudad'"
              formControlName="locationCity"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>
          </div>
        </div>
        <div class="map-input-container">
          <div>
            <app-select  [labelText]="'Departamento'" [placeholder]="'Seleccionar'" [required]="true"
               formControlName="locationState" [submitted]="submitted" [options]="states"></app-select>
          </div>
        </div>
      <div class="map-input-container">
        <app-text-input
          class="map-input-street-location"
          [labelText]="'Número de local, Piso o Unidad (Opcional)'"
          [type]="'text'"
          [max]="10"
          formControlName="depto"
          [submitted]="this.mapForm.get('depto')?.value?.length > 10"
        ></app-text-input>
      </div>
      <div class="map-input-container">
        <app-text-input
          [labelText]="'Comentarios adicionales (Opcional)'"
          [type]="'text'"
          [max]="40"
          formControlName="entreCalles"
          [submitted]="this.mapForm.get('entreCalles')?.value?.length > 40"
        ></app-text-input>
      </div>
    </div>
  </form>
</div>
